import { createReducer, on } from '@ngrx/store';

import { IEnfriadores } from '../../shared/models/Enfriadores.model';
import {
    clearEnfriadores,
    errorEnfriadores,
    getEnfriadores,
    successEnfriadores,
} from '../actions/enfriadores.actions';

/**
 * * Obtiene los datos de enfriadores para conexión url
 */
export interface EnfriadoresState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IEnfriadores;
}

export const EnfriadoresInit: EnfriadoresState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as IEnfriadores,
};

const _enfriadoresReducer = createReducer(
    EnfriadoresInit,
    on(getEnfriadores, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
            error: null,
        }
    )),
    on(successEnfriadores, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
            error: null,
        }
    )),
    on(errorEnfriadores, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(clearEnfriadores, state => ({ ...state, ...EnfriadoresInit })),
);

export function enfriadoresReducer(state: any, action: any) {
    return _enfriadoresReducer(state, action);
}
